export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14146.904170d2.jpg";